<template>
  <div>
    <div class="text-right">
      <b-button class="mr-2" right variant="success" @click="openModal('CREATE', null)">{{
        $t("public.views.Pages.Share.btnCreate")
      }}
      </b-button>
    </div>
    <v-data-table :footer-props="{
      showFirstLastPage: true,
      firstIcon: 'fas fa-arrow-left',
      lastIcon: 'fas fa-arrow-right',
      prevIcon: 'fas fa-minus',
      nextIcon: 'fas fa-plus',
      'items-per-page-options': [10, 25, 50],
    }" :headers="headersShare" :items="shares" :options.sync="paginationShare" :server-items-length="totalShare"
      item-key="id">
      <template v-slot:item.createdAt="{ item }">
        <div v-if="item.createdAt">
          {{ item.createdAt | adjustToTimezone("DD/MM/YYYY HH:mm") }}
        </div>
      </template>
      <template v-slot:item.uuid="{ item }">
        <div class="div-table-data">
          <button :id="'btnUpdate' + item.id" class="item" v-on:click="openModal('UPDATE', item.id)">
            <i class="ri-refresh-line"></i>
          </button>
          <b-popover :target="'btnUpdate' + item.id" placement="botton" triggers="hover focus">
            <template #title>{{
              $t("public.views.Pages.Share.btnUpdate")
            }}
            </template>
          </b-popover>

          <button :id="'btnDownload' + item.id" class="item" @click="downloadFile(item.uuid, item.filename)">
            <i class="ri-file-download-line text-black"></i>
          </button>
          <b-popover :target="'btnDownload' + item.id" placement="botton" triggers="hover focus">
            <template #title>{{
              $t("public.views.Pages.Share.btnDownload")
            }}
            </template>
          </b-popover>
        </div>
      </template>
      <template v-slot:item.category="{ item }">
        {{
          $t("public.views.Pages.Share.categories." + item.category)
        }}
      </template>

      <template v-slot:item.filename="{ item }">
        <div v-if="item.filename">
          <i v-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'mp4'
          " class="fas fa-file-video"></i>
          <i v-else-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'pdf'
          " class="fas fa-file-pdf"></i>
          <i v-else-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'png' ||
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'jpg' ||
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'jpeg' ||
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'gif'
          " class="fas fa-file-image"></i>
          <i v-else-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'word'
          " class="fas fa-file-word"></i>
          <i v-else-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'xls'
          " class="fas fa-file-excel"></i>
          <i v-else-if="
            item.filename
              .substring(
                item.filename.lastIndexOf('.') + 1,
                item.filename.length
              )
              .toLowerCase() === 'txt'
          " class="fas fa-file-alt"></i>
          <i v-else class="far fa-file"></i>
          {{ item.filename }}
        </div>
      </template>
    </v-data-table>
    <b-modal id="modal-create-hsitoric-files" cancel-title="Cerrar" centered @ok="saveFormStep1">
      <template #modal-title>
        <div v-if="action === 'CREATE'">
          {{ $t("public.views.Pages.Share.modalCreate.title") }}
        </div>
        <div v-if="action === 'UPDATE'">
          {{ $t("public.views.Pages.Share.modalCreate.titleUpdate") }}
        </div>
      </template>
      <template #modal-ok>{{
        $t("public.views.Pages.Share.modalCreate.save")
      }}
      </template>
      <template #modal-cancel>{{
        $t("public.views.Pages.Share.modalCreate.close")
      }}
      </template>
      <b-form-group label-for="name">
        <template slot="label">{{ $t("public.views.Pages.Share.name") }}: *
        </template>
        <b-form-input id="name" v-model="name" :disabled="disabled" type="text" v-bind:class="{
          'text-danger': isFormNameErrors,
          'is-invalid': isFormNameErrors,
        }" @blur="checkName(name)"></b-form-input>
        <ul v-if="isFormNameErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('name')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
      <b-form-group v-if="patient.name" label-for="user">
        <template slot="label">{{ $t("public.views.Pages.Share.user") }}: *
        </template>
        <b-avatar class="mr-3" v-bind:src="
          patient.avatarUrl
            ? patient.avatarUrl + '/' + getAuthentication()
            : ''
        "></b-avatar>
        <span class="mr-auto title-typography-color">{{ patient.name }} {{ patient.lastname }}</span>
      </b-form-group>
      <b-form-group label-for="file">
        <template slot="label">{{ $t("public.views.Pages.Share.file") }}: *
        </template>
        <vue-dropzone id="file" :options="dropzoneOptions" @vdropzone-success="vdropzoneSuccess"
          @vdropzone-error="vdropzoneError"></vue-dropzone>
        <a v-if="fileData && fileName" :download="fileName" :href="'data:application/octet-stream;base64,' + fileData">
          <i class="fas fa-download fa-fw"></i>{{ fileName }}
        </a>
        <ul v-if="isFormFileErrors">
          <li v-for="(error, index) in validatorStep1.getErrors('file')" v-bind:key="index" class="form-text text-danger">
            &nbsp;{{ error }}
          </li>
        </ul>
      </b-form-group>
    </b-modal>
  </div>
</template>
<script>
import { xray } from "../../config/pluginInit";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import moment from "moment";

import validator from "vue-m-validator";

import shareService from "../../services/share";
import patientService from "../../services/patient";
import utilsService from "../../services/utils";

export default {
  name: "HistoricsFiles",
  props: {
    patientId: undefined,
  },
  mounted() {
    xray.index();

    this.getPatient(this.patientId);
    this.getAllShares();
  },
  watch: {
    paginationShare: {
      handler() {
        if (this.start) {
          this.getAllShares();
        }
        this.start = true;
      },
    },
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    //Check if patient is in paths
    notFirst() {
      this.isFirstRun = false;
    },
    openModal(action, id) {
      this.action = action;

      if (this.action === "UPDATE") {
        this.getShare(id);
      } else {
        this.cleanAll();
        this.$bvModal.show("modal-create-hsitoric-files");
      }
    },
    getPatient(id) {
      let self = this;

      this.$awn.asyncBlock(
        patientService.get(id),
        (response) => {
          if (response) {
            self.patient = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "patientService.get",
            module: "view-pages-professional-wallet",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        }
      );
    },
    saveFormStep1(evt) {
      evt.preventDefault();
      this.checkFormStep1();
      if (this.validatorStep1.errors.length === 0) {
        //Call service to store data
        if (this.action === "CREATE") {
          this.create();
        }
        if (this.action === "UPDATE") {
          this.update();
        }

      } else {
        this.$notify({
          group: "notificacions",
          title: this.$i18n.t("public.views.Pages.Share.notification.error"),
          text: this.$i18n.t(
            "public.views.Pages.Share.notification.descErrorStep1"
          ),
          type: "error",
        });
      }
    },
    checkFormStep1() {
      this.checkName(this.name);
      this.checkFile(this.fileUUID);
    },
    cleanAll() {
      this.name = "";
      this.usersTo = [];
      this.fileUUID = "";
      this.fileUUID = "";
      this.fileName = "";
      this.fileData = "";
    },

    create() {
      let self = this;

      let usersTo = [];

      if (this.patient.id) {
        usersTo.push(this.patient.id);
      }

      let model = {
        userFrom: localStorage.getItem("userId"),
        usersTo: usersTo,
        name: this.name,
        category: this.category,
        fileUUID: this.fileUUID,
      };

      this.$awn.asyncBlock(
        shareService.create(model),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "CREATE", module: "PROFESSIONAL_SHARE_FILES", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Share.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Share.notification.descCreated"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-create-hsitoric-files");
            if (self.$route.query.patient) {
              self.getAllSharesByPatient();
            } else {
              self.getAllShares();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.create",
            module: "modal-create-hsitoric-files",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              model: model
            })
          });
        },
        " "
      );
    },
    update() {
      let self = this;

      let model = {
        id: this.id,
        userFrom: localStorage.getItem("userId"),
        usersTo: this.patient.id,
        name: this.name,
        category: this.category,
        fileUUID: this.fileUUID,
      };

      this.$awn.asyncBlock(
        shareService.update(model),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "UPDATE", module: "PROFESSIONAL_SHARE_FILES", info: "" });
            self.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.views.Pages.Share.notification.title"
              ),
              text: this.$i18n.t(
                "public.views.Pages.Share.notification.descRefresh"
              ),
              type: "success",
            });
            self.$bvModal.hide("modal-create-hsitoric-files");
            if (self.$route.query.patient) {
              self.getAllSharesByPatient();
            } else {
              self.getAllShares();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.update",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              model: model
            })
          });
        },
        " "
      );
    },
    getShare(id) {
      let self = this;
      this.$awn.asyncBlock(
        shareService.get(id),
        (response) => {
          if (response) {
            self.cleanAll();
            self.id = response.data.id;
            self.userFrom = response.data.from;
            self.usersTo = response.data.to;
            self.name = response.data.name;
            self.category = response.data.category;
            if (response.data.file) {
              self.fileUUID = response.data.file.uuid.replace("/", "");
              self.fileName = response.data.file.name;
              self.fileData = response.data.file.data;
            }
            self.$bvModal.show("modal-create-hsitoric-files");
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.get",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    async getAllShares() {
      let self = this;
      this.$awn.asyncBlock(
        shareService.getAllHistoric(
          this.paginationShare.page - 1,
          this.paginationShare.itemsPerPage,
          this.patientId
        ),
        (response) => {
          if (response) {
            self.shares = response.data.content;
            self.totalShare = response.data.pageable.total;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.getAllHistoric",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.paginationShare.page - 1,
              itemsPerPage: this.paginationShare.itemsPerPage,
              patientId: this.patientId
            })
          });
        },
        " "
      );
    },
    deleteFile(id) {
      let self = this;

      this.$awn.asyncBlock(
        shareService.delete(id),
        (response) => {
          if (response) {
            utilsService.auditActivity({ action: "DELETE", module: "PROFESSIONAL_SHARE_FILES", info: "" });
            if (self.$route.query.patient) {
              self.getAllSharesByPatient();
            } else {
              self.getAllShares();
            }
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "shareService.delete",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            })
          });
        },
        " "
      );
    },
    downloadFile(uuid, filename) {
      let self = this;
      this.$awn.asyncBlock(
        utilsService.getFile(uuid),
        (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/octet-stream;base64",
              name: "prueba",
            });

            saveAs(file, filename);
          }
        },
        (error) => {
          this.$notify({
            group: "notificacions",
            title: this.$i18n.t("public.views.Pages.Share.notification.error"),
            text: this.$i18n.t(
              "public.views.Pages.Share.notification.descErrorDwn"
            ),
            type: "error",
          });
          utilsService.auditErrorFrontent({
            info: "utilsService.getFile",
            module: "view-pages-professional-contact-hc",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: uuid
            })
          });
        },
        ""
      );
    },
    checkName(_name) {
      const NAME = _name.trim();
      const RULE_1 = {
        expression: !NAME || NAME === "",
        name: "name",
        msg: this.$i18n.t("public.views.Pages.Share.errors.erName"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    checkFile(_file) {
      const FILE = _file.trim();
      const RULE_1 = {
        expression: !FILE || FILE === "",
        name: "file",
        msg: this.$i18n.t("public.views.Pages.Share.errors.erFile"),
      };
      validator.addRule(RULE_1);
      this.notFirst();
    },
    vdropzoneError(file, response) {
      this.$notify({
        group: "notificacions",
        title: "Error",
        text: "Hay errores en el fichero que esta intentando subir",
        type: "error",
      });
      this.$bvModal.hide("modal-create-hsitoric-files");
    },
    vdropzoneSuccess: function (file, response) {
      this.fileUUID = response.uuid;
      this.fileName = response.name;
      this.getFile(this.fileUUID);
    },
    getFile(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.fileData = response.data.data;
          }
        })
        .catch(function (error) {

        });
    },
  },
  computed: {
    isFormFileErrors() {
      let errors = this.validatorStep1.getErrors("file");
      return errors && errors.length > 0;
    },
    isFormNameErrors() {
      let errors = this.validatorStep1.getErrors("name");
      return errors && errors.length > 0;
    },
  },
  data() {
    return {
      isFirstRun: true,
      //Form image
      dropzoneOptions: {
        url: process.env.VUE_APP_BASE_URL_CORE + "public/file/upload",
        thumbnailWidth: 200,
        maxFilesize: 2,
        addRemoveLinks: true,
        maxFiles: 1,
        dictDefaultMessage: "<i class='ri-upload-cloud-fill'></i>Subir",
      },
      validatorStep1: validator,
      shares: [],
      paginationShare: {},
      totalShare: 0,
      patient: undefined,
      //Form create new share
      id: "",
      usersTo: [],
      userFrom: localStorage.getItem("userId"),
      name: "",
      fileUUID: "",
      fileName: "",
      fileData: "",
      category: "HISTORIC",

      disabled: false,
      headersShare: [
        {
          text: "Fecha de creación",
          align: "start",
          value: "createdAt",
        },
        {
          text: "Título",
          value: "name",
        },
        {
          text: "Categoría",
          value: "category",
        },
        {
          text: "Nombre del archivo",
          value: "filename",
        },
        { text: "", value: "uuid" },
      ],
    };
  },
  components: {
    "vue-dropzone": vue2Dropzone,
  },
};
</script>